import { render, staticRenderFns } from "./Matrix.vue?vue&type=template&id=19c48814"
import script from "./Matrix.ts?vue&type=script&lang=js&external"
export * from "./Matrix.ts?vue&type=script&lang=js&external"
import style0 from "./Matrix.vue?vue&type=style&index=0&id=19c48814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports